// replicamos el nombre de las entidades de  los permisos
const TRAIN_DETAIL_PERMISSION_ENTITY = 'train-detail'
const AIR_DETAIL_PERMISSION_ENTITY = 'air-detail'
const VOUCHER_PERMISSION_ENTITY =  'voucher'
const PAX_PERMISSION_ENTITY = 'pax'
const DUE_DATE_RANGE_PERMISSION_ENTITY = 'due-date-range'

export {
  TRAIN_DETAIL_PERMISSION_ENTITY,
  AIR_DETAIL_PERMISSION_ENTITY,
  VOUCHER_PERMISSION_ENTITY,
  PAX_PERMISSION_ENTITY,
  DUE_DATE_RANGE_PERMISSION_ENTITY,
}